import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import OtpInput from 'react-otp-input';
import TextInput from '../../../../Shared/TextInput/TextInput';

const OtpCode = (props) => {
    const [code, setCode] = useState('');

    useEffect(() => {
        if (props.onSubmit) {
            props.validateOtp(code);
        }
    }, [props.onSubmit]);

  const handleChange = (otp) => {
    setCode(otp);
  };

  return (
    <div className='otp-code-sale'>
        <div className='component-container'>
            <div className='mainDiv'>
              <TextInput
              placeholder={'קוד אימות'}
              value={code}
              error={props.errorMsg}
              onChange={(e) => {handleChange(e.target.value);}}/>
            </div>
        </div>
        <div className='btn-wrapper'>
          <a href='#' onClick={() =>{props.createOtp(false)}}>הקוד לא הגיע, שלחו שוב</a>
          <a href='#' onClick={() =>{props.createOtp(true)}}>שילחו לי קוד בהודעה קולית</a>
        </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    errorMsg: state.saleJetBlock.otpDetails.errorMsg
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpCode);
